import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "content"]

  toggle() {
    if (this.isOpen()) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.sidebarTarget.classList.add("translate-x-0")
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.contentTarget.classList.add("ml-64")
    localStorage.setItem("sidebarOpen", "true")
  }

  close() {
    this.sidebarTarget.classList.add("-translate-x-full")
    this.sidebarTarget.classList.remove("translate-x-0")
    this.contentTarget.classList.remove("ml-64")
    localStorage.setItem("sidebarOpen", "false")
  }

  isOpen() {
    return !this.sidebarTarget.classList.contains("-translate-x-full")
  }
}
